import { ReactComponent as CollapseIcon } from './collapse.svg';

export default CollapseIcon;
